<template lang="pug">
  .view-subfinalscope
    title-bar {{ $t('SOW信息') }}
    div(style="margin-left: 20px")
      el-row
        el-col(:span="4").text-left {{ $t('项目名称') }}
        el-col(:span="20") {{ data.campaign_name || '—' }}
      template(v-for="item in data.brand")
        el-row
          el-col(:span="4").text-left {{ $t('品牌类别') }}
          el-col(:span="20") {{ item.brand_category_name || '—' }}
        el-row
          el-col(:span="4").text-left {{ $t('品牌') }}
          el-col(:span="20") {{ item.brand_name || '—' }}
      Category(:data="data.category")
      el-row
          el-col(:span="4").text-left {{ $t('Sub SOW') }}
          el-col(:span="20") {{ data.sub_final_scope_name || '—' }}
      el-row
        el-col(:span="4").text-left {{ $t('Sub SOW附件') }}
        el-col(:span="20")
          uploaded-file-display(
            :fileName="data.spotplan_name"
            :downloadUrl="data.spotplan_download_path"
            width="85px"
          )
      el-row
          el-col(:span="4").text-left {{ $t('描述') }}
          el-col(:span="20") {{ data.introduction || '—' }}
</template>

<script>
import axios from 'axios'
import TitleBar from '@/components/TitleBar'
import UploadedFileDisplay from '@/components/UploadedFileDisplay'
import Category from '@/components/Category'
import FooterButton from '@/components/FooterButton'

export default {
  components: {
    UploadedFileDisplay,
    TitleBar,
    Category,
    FooterButton
  },
  data () {
    return {
      data: {}
    }
  },
  computed: {
    subFinalScopeId () {
      return this.$store.state.campaign.subFinalScopeId
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      axios
        .get('/vendor/vendor/getServiceContent', {
          params: {
            sub_final_scope_id: this.subFinalScopeId
          }
        })
        .then((res) => {
          this.data = res
        })
    }
  }

}
</script>

<style lang="stylus">

</style>
